import styled from 'styled-components';

export const GridContainer = styled.div`
  // todo: fix this
  height: 100%;

`;
